<div class="roster-search">
  <nb-icon class="search-icon" icon="search-outline"></nb-icon>
  <input nbInput type="text" fieldSize="small" [(ngModel)]="filter"
         placeholder="{{ 'dashboard.team.search_member' | translate }}"
         [attr.aria-label]="'dashboard.team.search_member' | translate">
  <button *ngIf="filter" type="button" class="clear-btn" (click)="clearFilter()"
          [attr.aria-label]="'clear' | translate"><nb-icon icon="close-circle"></nb-icon></button>
</div>
<table class="roster">
  <thead>
    <tr>
      <th>{{ 'dashboard.team.member' | translate }}</th>
      <th>{{ 'dashboard.team.util' | translate }}</th>
      <th>{{ 'dashboard.team.hours' | translate }}</th>
      <th>{{ 'dashboard.team.timesheet' | translate }}</th>
      <th>{{ 'dashboard.team.ends' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows" class="roster-row">
      <td><button type="button" class="row-action" (click)="select(row, $event)">{{ row.name }}</button></td>
      <td>
        <div class="u-cell">
          <span class="u-mini"><i [style.width.%]="row.utilization === null ? 0 : row.utilization" [class.nocap]="row.utilization === null"></i></span>
          <span class="uv">{{ row.utilization !== null ? row.utilization + '%' : '—' }}</span>
        </div>
      </td>
      <td>{{ row.hours }}</td>
      <td><span class="chip" [class.chip-sub]="row.timesheetStatus === 'submitted' || row.timesheetStatus === 'approved'"
          [title]="row.timesheetDecidedBy ? ('dashboard.timesheet.decided_by' | translate:{ who: row.timesheetDecidedBy, when: (row.timesheetDecidedAt | date:'d MMM') }) : ''">{{ ('dashboard.ts_status.' + row.timesheetStatus) | translate }}</span></td>
      <td>{{ row.assignmentEndsOn ? (row.assignmentEndsOn | date:'d MMM y') : '—' }}</td>
    </tr>
    <tr *ngIf="rows.length === 0">
      <td colspan="5" class="roster-empty">{{ 'dashboard.team.no_match' | translate }}</td>
    </tr>
  </tbody>
</table>
